import type { NotificationLevel } from '@gat-ship/error-handling'

/**
 * shadcn/reka-ui's Toast component only ships two variants out of the box:
 * `default` (neutral) and `destructive` (red). Everything non-error gets
 * the default variant; extend `toastVariants` in vue-components if richer
 * per-level styling is ever needed.
 */
export function variantForLevel(
  level: NotificationLevel
): 'default' | 'destructive' {
  return level === 'error' ? 'destructive' : 'default'
}

/**
 * Whether a toast id has already been handed off to the Toaster in the
 * current in-flight burst. Pure predicate over the shell-owned `processed`
 * Set — the mutable Set itself stays in the component (it's side-effect
 * state, not a decision).
 */
export function isAlreadyProcessed(
  processedIds: ReadonlySet<string>,
  id: string
): boolean {
  return processedIds.has(id)
}
